import { RootState } from 'store/rootReducer';
import { HeroTeaserDto } from '@cp-es/common';
import { AbstractContentState } from '@cp-shared-10/frontend-integration';

export const LandingPageHeroTeaserContentSelector = (state: RootState): AbstractContentState<HeroTeaserDto> =>
    state.content.landingPageHeroTeaser;
